// $(document).ready(function(){
//    function AddReadMore() {
//       var carLmt = 300;
//       var readMoreTxt = $('.product .product__description').attr('data1');
//       var readLessTxt = $('.product .product__description').attr('data2');

//       $(".add-read-more").each(function () {
//          if ($(this).find(".first-section").length)
//             return;

//          var allstr = $(this).html();
//          var strippedStr = $(this).text();

//          if (strippedStr.length > carLmt) {
//             var firstSet = strippedStr.substring(0, carLmt);
//             var secdHalf = allstr.substring(firstSet.length, allstr.length);
//             var strtoadd = "<span class='first-section'>" + firstSet + "</span><span class='second-section'>" + secdHalf + "</span><span class='read-more' title='Click to Show More'>" + readMoreTxt + "</span><span class='read-less' title='Click to Show Less'>" + readLessTxt + "</span>";
            
//             $(this).html(strtoadd);
//          }
//       });

//       $(document).on("click", ".read-more,.read-less", function () {
//          $(this).closest(".add-read-more").toggleClass("show-less-content show-more-content");
//       });
//    }

//    AddReadMore();
// });

document.addEventListener('DOMContentLoaded', function() {
  const readMoreBtn = document.querySelector('.read_more');
  const productDescription = document.querySelector('.product__description');

  if (readMoreBtn && productDescription) {
    readMoreBtn.addEventListener('click', function() {
      // Toggle the class on product__description div when the button is clicked
      productDescription.classList.toggle('active');
    });
  }
});







